import React from 'react';
import '../../styles/online-payment/main.css';

const Main = () => {
    return (
        <div id='onlinePaymentMain'>
            <div className="online-payment-main">
                <div className="container main-box">
                    <div className="box">
                        <div className="col-lg-5 col-sm-12">
                            <div className="image">
                                <span>Online Fees Payment For Campus Courses</span>
                                <img src="../assets/images/admission-back.jpg" alt="" />
                            </div>
                        </div>
                        <div className="col-lg-7 col-sm-12">
                            <div className="links">
                                <div className="link">
                                    <span>
                                        <img src="../assets/images/link.svg" alt="" />
                                    </span>
                                    <div className="content">
                                        <a
                                            href="http://forms.ccsuresults.com/exams/FeePayPanel/"
                                            target="blank"
                                        >
                                            <p>Online Fees Payment For Campus Courses</p>
                                        </a>
                                        {/* <p>Campus Admission Portal 2023</p> */}
                                    </div>
                                </div>
                                <div className="link">
                                    <div className="content">
                                        <span>
                                            B.P.Ed. <br />
                                            B.Sc.(Food Microbiology, Quality &amp; Safety Control) &amp;
                                            B.Sc.(Food Microbiology) <br />
                                            M.P.Ed. <br />
                                            M.Phil.(Microbiology) <br />
                                            M.Sc.(Medical Microbiology) <br />
                                            M.Sc.(Bio-Informatics) <br />
                                            M.Sc.(Applied Microbiology) <br />
                                            M.Sc.(Microbiology) &amp; M.Sc.(Microbiology CBCS ) <br />
                                            M.Sc.(ZOOLOGY CBCS ) <br />
                                            <br />
                                            <br />
                                            B.COM (Honors)
                                            <br />
                                            M.COM (CBCS)
                                            <br />
                                            L.L.M <br />
                                            B.A L.L.B. <br />
                                            MFA <br />
                                            Library &amp; Information Sc. <br />
                                            B.A.&amp; M.A. (HONOURS ECONOMICS)
                                            <br />
                                            M.A.(Political Science) <br />
                                            M.A.(Public Administration)
                                            <br />
                                            M.S.W , M.A (Sociology) <br />
                                            Environment Science <br />
                                            BPES
                                            <br />
                                            L.L.B <br />
                                        </span>
                                        {/* <p>Campus Admission Portal 2023</p> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    )
}

export default Main;